// @flow
import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';

type Props = {
  transcriptId: string,
  scribeCreateTranscript: Function,
};
const ScribeCreateTranscript = ({ transcriptId, scribeCreateTranscript }: Props) => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      margin: '-8px 0',
      opacity: 0.6,
    }}
  >
    <IconButton
      size="small"
      onClick={() => {
        scribeCreateTranscript(transcriptId);
      }}
    >
      <AddIcon />
    </IconButton>
  </div>
);
export default ScribeCreateTranscript;
